import React from 'react'
import '../style/style.css'
import FrontEnd from '../img/FrontEnd.png'
import database from "../img/db.png";
import Backend from "../img/BackEnd.png";
import PG_Environment from "../img/PE.png";
import PG_lang from "../img/pl.png";
import {motion} from 'framer-motion'


export default function Skills() {
    return (
      <motion.div 
        initial={{opacity:0 , y:"-100%"}} 
        animate={{opacity:1 , y:0}} 
        exit={{opacity:0 , y:"-100%"}} 
        transition={{type:"spring"}}
        className="col-lg-9 col-md-9 col-sm-9 col-xs-12"> 

        <div className="container">
          <h1>Skills</h1>  
          <div id="myCarousel" className="carousel slide" data-ride="carousel"> 
            <ol className="carousel-indicators">
              <li data-target="#myCarousel" data-slide-to="0" className="active"></li>
              <li data-target="#myCarousel" data-slide-to="1"></li>
              <li data-target="#myCarousel" data-slide-to="2"></li>
              <li data-target="#myCarousel" data-slide-to="2"></li>
              <li data-target="#myCarousel" data-slide-to="2"></li>
            </ol>
 
            <div className="carousel-inner">
            <div className="item active">
                <img src={FrontEnd}  alt="frontend language" style={{width:"750px" , height:"500px"}} />
              </div>
              
              <div className="item">
                <img src={PG_lang} alt="Programming language" style={{width:"750px" , height:"500px"}}/>
              </div>

              <div className="item">
                 <img src={Backend} alt="Backend language" style={{width:"750px" , height:"500px"}} />
              </div>
        
              <div className="item">
                 <img src={database} alt="database" style={{width:"750px" , height:"500px"}}/>
              </div>

              <div className="item">
                <img src={PG_Environment} alt="programming environment" style={{width:"750px" , height:"500px"}} />
              </div>
            </div>
 
            <a className="left carousel-control" href="#myCarousel" data-slide="prev">
              <span className="glyphicon glyphicon-chevron-left"></span>
              <span className="sr-only">Previous</span>
            </a>
            <a className="right carousel-control" href="#myCarousel" data-slide="next">
              <span className="glyphicon glyphicon-chevron-right"></span>
              <span className="sr-only">Next</span>
            </a>
          </div>
      </div>
      </motion.div>
    )
}
